module.exports = __webpack_public_path__ + "static/img/recruit.878e27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/recruit.png
// module id = cyHw
// module chunks = 1